import { Button } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Layout from "../../Layout";
import HeaderBread from "../../components/HeaderBread";
import { useDataLayerValue } from "../../DataLayer/DataLayer";
import { addlog } from "../../utils/ApiCalls/Logs";

import CustomHeaderTitle from "../../components/constants/CustomHeaderTitle";
import {
  deletePromoIndex,
  getPromoIndex,
  updatePromoIndex,
} from "../../utils/ApiCalls/PromoIndex";
import CustomizedTable from "../../components/UI/CustomizedTable";
import SwitchBar from "../../components/Pages/SwitchBar";
import { checkPermission } from "../../utils/Validation/checkPermission";
import { message } from "antd";
import PromoIndexEdit from "../../constants/PromoIndexEdit";
import Logs from "../../components/Logs";
import PromoIndex from "../../components/UI/PromoIndex";
import MultiSelectData from "../../components/UI/MultiSelectData";
import Swal from "sweetalert2";
import DeletePop from "../../constants/ErrorPermissionModal";

const Promos = () => {
  const navigate = useNavigate();
  const navigation = [
    {
      title: "Home",
      route: "/",
    },
    {
      title: "Promo Index",
      route: "/website/cms/promo-index",
    },
  ];
  const [rows, setRows] = useState([]);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState("listing");
  const [{ userDetails, permission }, dispatch] = useDataLayerValue();
  const [promoIndexs, setPromoIndexs] = useState([]);
  const [promoIndex, setPromoIndex] = useState("");
  const [cruise_type, setCruiseType] = useState(["itravel","seaware"]);
  const [selected_cruise_type, setSelectedCruiseType] = useState([]);

  
  const locationP = useLocation();

  const [page, setPage] = useState(
    () => parseInt(new URLSearchParams(locationP.search).get("page")) || 1
  );
  const [pageSize, setPageSize] = useState(
    () => parseInt(new URLSearchParams(locationP.search).get("pageSize")) || 10
  );
  const [search, setSearch] = useState(
    () => new URLSearchParams(locationP.search).get("search") || ""
  );

  useEffect(() => {
    const params = new URLSearchParams(locationP.search);
    const pageParam = parseInt(params.get("page")) || 1;
    const pageSizeParam = parseInt(params.get("pageSize")) || 10;

    // setPage(pageParam);
    // setPageSize(pageSizeParam);
  }, [locationP.search]);

  useEffect(() => {
    const params = new URLSearchParams();
    const currentParams = new URLSearchParams(locationP.search);

    params.set("page", page);
    params.set("pageSize", pageSize);

    if (currentParams.toString() !== params.toString()) {
      navigate({ search: params.toString() }, { replace: true });
    }
  }, [page, pageSize, navigate, locationP.search]);


  const columns = [
    {
      title: "Sl",
      width: 10,
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (position, record, index) => (page - 1) * pageSize + index + 1,
    },
    {
      title: "Promo Index",
      dataIndex: "promo_index",
      key: "promo_index",
      width: 50,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 300,
      render: (item) => <p>{item}</p>,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 500,
      render: (item) => <p>{item}</p>,
    },
    {
      title: "Status",
      dataIndex: "is_active",
      key: "is_active",
      width: 100,
      sorter: (a, b) => a.is_active - b.is_active,
      render: (isActive, record) => (
        <div className="custom-control custom-switch">
          <input
            type="checkbox"
            checked={!!isActive}
            onChange={(e) => {
              const newStatus = e.target.checked ? 1 : 0;
              try {
                handleUpdate(record.promo_index, { is_active: newStatus });
              } catch (error) {
                dispatch({ type: "SET_LOADING", loading: false });

                Swal.fire({
                  icon: "error",
                  title: "Oops...",
                  text: error?.message || "Unknown error occurred",
                });
              }
            }}
            className="custom-control-input"
            id={`customSwitch${record.promo_index}`}
          />
          <label
            className="custom-control-label"
            htmlFor={`customSwitch${record.promo_index}`}
          ></label>
        </div>
      ),
    },

    {
      title: "Action",
      key: "operation",
      width: 50,
      render: (item, record) => {
        return (
          <div className="table_action_btn">
            <PromoIndexEdit record={record} handleUpdate={handleUpdate} />{" "}
            <DeletePop onConfirm={() => handleDelete(record.promo_index)}>
              <div>
                {" "}
                <button className="btn delete_btn">
                  <i
                    className="ri-delete-bin-line"
                    data-toggle="tooltip"
                    title="Delete"
                  ></i>
                </button>
              </div>
            </DeletePop>
          </div>
        );
      },
    },
  ];
  useEffect(() => {
    getData(page);
  }, [page, pageSize,selected_cruise_type]);

  const getData = async (value) => {
    let args = { page: value, limit: pageSize };
    if (promoIndex) {
      args = { ...args, promoIndex };
    }
    args={...args,cruiseType:selected_cruise_type}
    let data = await getPromoIndex(args);
    if (data.error) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: data.error, type: "error" },
      });
    } else if (data.data) {
      setRows(data.data);
      setCount(data.count);
      if (data?.promoIndex) {
        data.promoIndex.unshift({ promo_index: "All" });
        setPromoIndexs(data.promoIndex);
      }
    }
  };
 const handleDelete = async (id) => {
    if (checkPermission(permission, "delete_per", "Promo Index",window?.location?.pathname)) {
      await deletePromoIndex(id);
      getData(page);
    } else {
      message.error("Missing Permission for delete");
    }
  };
  const handleUpdate = async (id, values) => {
    if (checkPermission(permission, "update_per", "Promo Index",window?.location?.pathname)) {
      let data = await updatePromoIndex(id, values);
      if (data.error) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: data.error, type: "error" },
        });
      } else {
        addlog("Promo index updated", "Promo_Index", { id }, userDetails.id);
        message.success("Updated Successfully!");
      }
      getData(page);
    } else {
      message.error("Update permission missing");
    }
  };

  return (
    <Layout type={"read_per"} module_data={"Promo Index"}>
      <CustomHeaderTitle title={"Promo Index"} />
      <div>
        <div>
          <HeaderBread
            navigation={navigation}
            title={"Promo Index"}
          ></HeaderBread>
        </div>
        <section className="content" style={{ marginTop: "20px" }}>
          <div className="container-fluid">
            <SwitchBar
              tabs={[
                { title: "Promo Index", value: "listing" },
                { value: "logs", title: " History Logs" },
              ]}
              activeTab={active}
              setActiveTab={setActive}
            />
            {active === "listing" && (
              <div className="card">
                <div className="card-header two_item">
                  <h5 className="card-title">Promo Index List</h5>
                  <div className="two_item">
                    <PromoIndex
                      width={"150px"}
                      data={promoIndexs}
                      getData={getData}
                      promoIndex={promoIndex}
                      setPromoIndex={setPromoIndex}
                      setPage={setPage}
                    />
                    <MultiSelectData
                      data={cruise_type}
                      value={selected_cruise_type}
                      getData={getData}
                      label={"Select Cruise Type"}
                      setValue={setSelectedCruiseType}
                      sx={{ width: "100%" }}
                    />
                  </div>
                </div>
                <div className="card-body">
                  <div className="table_holder">
                    <CustomizedTable
                      setRows={setRows}
                      setPageSize={setPageSize}
                      setPage={setPage}
                      pageSize={pageSize}
                      page={page}
                      count={count}
                      columns={columns}
                      rows={rows}
                      title={"Promo Index"}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </section>
        {active === "logs" && (
          <Logs
            type={"Promo_Index"}
            slug={"/website/cms/packages/edit/"}
            refreshlog={active}
          />
        )}
      </div>
    </Layout>
  );
};

export default Promos;
